import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", function(value, format) {
  if (value) {
    if (format) return moment(String(value)).format(format);
    return moment(String(value)).format("MM/DD/YYYY hh:mm A");
  }
  return "--";
});

Vue.filter("humanMillis", function(value) {
  if (value == 0) return "All day";
  var eventMDuration = moment.duration(value / 1000, "seconds");
  var eventDurationArray = [];
  if (eventMDuration.years() > 0) {
    eventDurationArray.push(eventMDuration.years() + " years");
    eventMDuration.subtract(eventMDuration.years(), "years");
  }
  if (eventMDuration.months() > 0) {
    eventDurationArray.push(eventMDuration.months() + " months");
    eventMDuration.subtract(eventMDuration.months(), "months");
  }
  if (eventMDuration.weeks() > 0) {
    eventDurationArray.push(eventMDuration.weeks() + " weeks");
    eventMDuration.subtract(eventMDuration.weeks(), "weeks");
  }
  if (eventMDuration.days() > 0) {
    eventDurationArray.push(eventMDuration.days() + " days");
    eventMDuration.subtract(eventMDuration.days(), "days");
  }
  if (eventMDuration.hours() > 0) {
    eventDurationArray.push(
      eventMDuration.hours() === 1
        ? eventMDuration.hours() + " hour"
        : eventMDuration.hours() + " hours"
    );
    eventMDuration.subtract(
      eventMDuration.hours() === 1
        ? eventMDuration.hours() + " hour"
        : eventMDuration.hours() + " hours"
    );
  }
  if (eventMDuration.minutes() > 0) {
    eventDurationArray.push(eventMDuration.minutes() + " minutes");
  }
  return eventDurationArray.length === 1
    ? eventDurationArray[0]
    : eventDurationArray.join(" and ");
});
